// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MockupPlaceholder_wrapper__w7XNV","svg":"MockupPlaceholder_svg__w_4GK","placeholder":"MockupPlaceholder_placeholder__pS4_C","shine":"MockupPlaceholder_shine__inNu7"};